<template>
    <div v-if="section.is_active">
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="hammer_and_job_adviser">Hammer GPS &amp; Job Adviser</h2>
        <div class="flex lg:hidden justify-center">
            <img 
                src="/proposal-presentation-files/img/hammer-job-adviser-mobile.png" 
                class="cursor-pointer" 
                alt="Hammer GPD &amp; Job Adviser"
                data-src-large="/proposal-presentation-files/img/ja-funnel.png" 
                @click="enlargeImage"
            >
        </div>
        <div class="hidden lg:flex mt-4 mb-16 mx-8 justify-center">
            <img 
                src="/proposal-presentation-files/img/hammer-job-adviser.png" 
                alt="Hammer GPD &amp; Job Adviser"
                class="duration-500 hover:scale-105 cursor-pointer"
                data-src-large="/proposal-presentation-files/img/ja-funnel.png" 
                @click="enlargeImage"
            >
        </div>

        <proposal-modal-image
            v-if="modalImage"
            :modal-image-url="modalImageUrl"
            :modal-image-container="modalImageContainer"
            @close="modalImage = false"
        />
    </div>
</template>

<script>
import ProposalModalImage from "./proposal-modal-image";
import sellingPointMixin from '../sellingPointMixin';

export default {
    components: {
        ProposalModalImage,
    },
    mixins: [
        sellingPointMixin
    ],
    props: [
        'section',
    ],
}
</script>